import { api } from './client';

type Envelope<T> = { data: T };

export type WebhookSubscription = {
  id: string;
  name: string;
  url: string;
  events: string[];
  isActive: boolean;
  lastDeliveryAt: string | null;
  lastErrorAt: string | null;
  createdAt: string;
};

export type WebhookCreated = WebhookSubscription & { secret: string };

export type WebhookDelivery = {
  id: string;
  event: string;
  statusCode: number | null;
  errorMessage: string | null;
  attempts: number;
  deliveredAt: string | null;
  createdAt: string;
};

export const webhooksApi = {
  async listEvents(): Promise<string[]> {
    const { data } = await api.get<Envelope<string[]>>('/webhooks/events');
    return data.data;
  },

  async list(): Promise<WebhookSubscription[]> {
    const { data } = await api.get<Envelope<WebhookSubscription[]>>('/webhooks');
    return data.data;
  },

  async create(input: { name: string; url: string; events: string[] }): Promise<WebhookCreated> {
    const { data } = await api.post<Envelope<WebhookCreated>>('/webhooks', input);
    return data.data;
  },

  async delete(uuid: string): Promise<void> {
    await api.delete(`/webhooks/${uuid}`);
  },

  async listDeliveries(uuid: string): Promise<WebhookDelivery[]> {
    const { data } = await api.get<Envelope<WebhookDelivery[]>>(`/webhooks/${uuid}/deliveries`);
    return data.data;
  },

  async retryDelivery(deliveryUuid: string): Promise<void> {
    await api.post(`/webhooks/deliveries/${deliveryUuid}/retry`);
  },
};
